import React from "react";
import "./section-label.scss";

export interface SectionLabelProps {
  /** Text to display as the section heading. */
  label: string;
  /** Custom accent bar color. Defaults to Tertiary Blue 4 (#0056D6). */
  accentColor?: string;
  /** Truncates the label with ellipsis when it overflows the available width. */
  truncate?: boolean;
  /** Optional content rendered after the label (e.g. a badge or action). */
  endContent?: React.ReactNode;
  /** Additional CSS class for the root element. */
  className?: string;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({
  label,
  accentColor,
  truncate = false,
  endContent,
  className = "",
}) => {
  const style = accentColor
    ? ({ "--section-label-accent": accentColor } as React.CSSProperties)
    : undefined;

  return (
    <div className={`section-label ${className}`.trim()} style={style}>
      <span className="section-label__accent" aria-hidden />
      <span
        className={`section-label__text ${truncate ? "section-label__text--truncate" : ""}`}
        title={truncate ? label : undefined}
      >
        {label}
      </span>
      {endContent && (
        <span className="section-label__end">{endContent}</span>
      )}
    </div>
  );
};
